document.addEventListener('click', ({ target }) => {
  if (target.matches('.site-footer__link--top > span') && !target.parentNode.matches('.site-footer__link--active')) {
    [...document.querySelectorAll('.site-footer__link--top')].map((e) =>
      e.classList.remove('site-footer__link--active')
    );
    target.parentNode.classList.toggle('site-footer__link--active');
  } else if (
    target.matches('.site-footer__link--top > span') &&
        target.parentNode.matches('.site-footer__link--active')
  ) {
    target.parentNode.classList.remove('site-footer__link--active');
  }
});

document.addEventListener('click', ({ target }) => {
  if (
    target.matches('.site-footer__link--accordion > span') &&
        !target.parentNode.matches('.site-footer__link--active')
  ) {
    [...document.querySelectorAll('.site-footer__link--accordion')].map((e) =>
      e.classList.remove('site-footer__link--active')
    );
    target.parentNode.classList.toggle('site-footer__link--active');
  } else if (
    target.matches('.site-footer__link--accordion > span') &&
        target.parentNode.matches('.site-footer__link--active')
  ) {
    target.parentNode.classList.remove('site-footer__link--active');
  }
});


document.addEventListener('click', ({ target }) => {
  if (!target.matches('.lang-select__button')) return;

  target.closest('body').querySelector('.lang-select-modal').classList.add('active');
});

document.addEventListener('click', ({ target }) => {
  if (!target.matches('.lang-select-modal__close')) return;

  target.closest('.lang-select-modal').classList.remove('active');
});